import React, { ReactElement } from 'react';
import type { Route } from 'next';
import classNames from 'classnames/bind';
import Breadcrumbs from 'components/Breadcrumbs';
import styles from 'sections/Resources/TermsAndConditions/components/SectionHeader/SectionHeader.module.scss';

const cn = classNames.bind(styles);

const SectionHeader = (): ReactElement => {
  return (
    <section className={cn('header')}>
      <div className={cn('container')}>

        <Breadcrumbs mTop={64} mode="dark" links={[{ title: 'Privacy Policy', href: '' as Route }]} />

        <h1 className={cn('header__heading')}>Terms & Conditions</h1>

      </div>
    </section>
  );
};

export default SectionHeader;